import i18next from "i18next";

export const normalizeErrorMessage = (backendMessage: string, httpCode?: number): string => {
  if (httpCode === 500 || httpCode === 403 || httpCode === 404 || !backendMessage || backendMessage.trim() === "") {
    return i18next.t("commons.tryAgainLater");
  }

  return backendMessage;
};
